<template>
  <el-select
    ref="select"
    v-model="curValue"
    :filterable="filterable"
    :clearable="clearable"
    v-bind="$attrs"
    :placeholder="placeholder"
    :remote="remote"
    :remote-method="setQuery"
    v-on="$listeners"
  >
    <el-option
      v-for="item in computedOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      :disabled="disable(item)"
    >
    </el-option>
  </el-select>
</template>
<script>
import status from './status'
import gameTag from './gameTag'
import { debounce } from 'lodash-es'

const MAPPER = {
  status,
  gameTag,
}

export default {
  name: 'TypeSelect',
  props: {
    value: {
      type: [String, Number, Boolean, Array],
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Function,
      default: function (item) {
        console.log('item self', item)
        return false
      },
    },
  },
  data() {
    return {
      curValue: this.value,
      options: this.getOptions(),
      placeholder: this.getPlaceholder(),
      query: '',
      queryOptions: [],
    }
  },
  computed: {
    remote() {
      const data = MAPPER[this.type]
      return !!data?.remote && this.filterable
    },
    computedOptions() {
      if (this.filterable && this.remote) return this.queryOptions
      return this.options
    },
  },
  watch: {
    value(val) {
      this.curValue = val
    },
    curValue(val) {
      this.$emit('input', val)
    },
    query(val) {
      this.queryResult(val)
    },
  },
  created() {
    console.log('this.$attrs', this.$attrs)
    if (this.type === 'payType') {
      console.log('this.listeners', this.$listeners)
    }
  },
  methods: {
    setQuery(query) {
      if (!this.filterable) return
      this.query = query
    },
    queryResult: debounce(function () {
      if (!this.remote) return
      const data = MAPPER[this.type]
      data.getOptions(this.query).then(res => {
        this.queryOptions = res
      })
    }, 100),
    filterMethod(query) {
      this.query = query
    },
    getOptions() {
      if (!this.type || !MAPPER[this.type]) {
        return []
      }
      const data = MAPPER[this.type]
      if (!data.async) return data.getOptions()
      if (!(this.filterable && this.remote)) {
        data.getOptions().then(res => {
          this.options = res
        })
      }
      return []
    },
    getPlaceholder() {
      const data = MAPPER[this.type]
      return data?.placeholder || '请选择'
    },
    getSelectedLabel() {
      return this.$refs.select.selectedLabel
    },
  },
}
</script>
